import React from 'react';
import MarkdownRenderer from '../markdown/MarkdownRenderer';

function MessageList({ messages, messagesEndRef, backendError, isPrivate }) {
  if (backendError) {
    return (
      <div className={`flex-1 overflow-y-auto p-4 ${isPrivate ? 'bg-black text-white' : 'bg-white dark:bg-gray-900'}`}>
        <div className="mb-4 p-3 bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200 rounded-lg">
          <div className="font-bold">Eroare de conexiune</div>
          <p>{backendError}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`flex-1 overflow-y-auto p-4 ${isPrivate ? 'bg-black text-white' : 'bg-white dark:bg-gray-900'}`}>
      {messages.length === 0 ? (
        <div className="flex h-full items-center justify-center">
          <div className="text-center p-6 max-w-md">
            <h2 className={`text-2xl font-semibold mb-2 ${isPrivate ? 'text-white' : 'text-gray-700 dark:text-gray-300'}`}>
              Conversație nouă
            </h2>
            <p className={`${isPrivate ? 'text-gray-300' : 'text-gray-500 dark:text-gray-400'}`}>
              Trimite un mesaj pentru a începe o conversație nouă.
            </p>
          </div>
        </div>
      ) : (
        <div className="space-y-6">
          {messages.map((message, index) => (
            <div
              key={index}
              className={`flex ${message.role === 'user' ? 'justify-end' : 'justify-start'}`}
            >
              <div
                className={`max-w-3xl p-3 rounded-lg ${
                  message.role === 'user'
                    ? isPrivate
                      ? 'bg-gray-900 text-white' 
                      : 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-100'
                    : isPrivate
                      ? 'bg-gray-800 text-white'
                      : 'bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-200'
                }`}
              >
                {message.role === 'assistant' && !message.content ? (
                  <div className="flex justify-center">
                    <div className="loader"></div>
                  </div>
                ) : (
                  <MarkdownRenderer content={message.content} />
                )}
              </div>
            </div>
          ))}
          <div ref={messagesEndRef} />
        </div>
      )}
    </div>
  );
}

export default MessageList; 